/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FilterSeverityRatesDto
 */
export interface FilterSeverityRatesDto {
    /**
     * 
     * @type {number}
     * @memberof FilterSeverityRatesDto
     */
    minPercentage?: number;
    /**
     * 
     * @type {number}
     * @memberof FilterSeverityRatesDto
     */
    maxPercentage?: number;
}

/**
 * Check if a given object implements the FilterSeverityRatesDto interface.
 */
export function instanceOfFilterSeverityRatesDto(value: object): value is FilterSeverityRatesDto {
    return true;
}

export function FilterSeverityRatesDtoFromJSON(json: any): FilterSeverityRatesDto {
    return FilterSeverityRatesDtoFromJSONTyped(json, false);
}

export function FilterSeverityRatesDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FilterSeverityRatesDto {
    if (json == null) {
        return json;
    }
    return {
        
        'minPercentage': json['minPercentage'] == null ? undefined : json['minPercentage'],
        'maxPercentage': json['maxPercentage'] == null ? undefined : json['maxPercentage'],
    };
}

export function FilterSeverityRatesDtoToJSON(json: any): FilterSeverityRatesDto {
    return FilterSeverityRatesDtoToJSONTyped(json, false);
}

export function FilterSeverityRatesDtoToJSONTyped(value?: FilterSeverityRatesDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'minPercentage': value['minPercentage'],
        'maxPercentage': value['maxPercentage'],
    };
}

